import { z } from "zod";

/**
 * Body for the LTL BFF "credit-cards-customer-prepayment/send" success email,
 * built after a successful Braintree SubmitPayment and before the final
 * tender call. Mirrors the legacy `QuoteBOL` shape.
 */
export const prepayPaymentSchema = z.object({
	accountType: z.string(),
	isLumpSum: z.boolean(),
	confirmationNumber: z.string(),
	lastFour: z.string(),
	amountPaid: z.string(),
	comments: z.string(),
	tqlPos: z.array(z.string()),
});

export type PrepayPayment = z.infer<typeof prepayPaymentSchema>;

/**
 * Flattened customer block the BFF expects for the prepay success email.
 * The endpoint validates `email`, `brokerName`, `brokerEmail`, and
 * `ltlBrokerEmail` as required, so they must be populated (not the raw
 * nested `CustomerDetails` object).
 */
export const prepayCustomerInfoSchema = z.object({
	name: z.string(),
	email: z.string(),
	brokerName: z.string(),
	ltlBrokerEmail: z.string(),
	brokerEmail: z.string(),
	ltlBrokerId: z.number(),
	brokerId: z.number(),
	id: z.number(),
});

export type PrepayCustomerInfo = z.infer<typeof prepayCustomerInfoSchema>;

export const prepayQuoteBolSchema = z.object({
	quoteId: z.number(),
	customer: prepayCustomerInfoSchema,
	payment: prepayPaymentSchema,
	toEmails: z.array(z.string()),
	tqlpo: z.number(),
	customerCost: z.number(),
});

export type PrepayQuoteBol = z.infer<typeof prepayQuoteBolSchema>;

/**
 * Body for the failure email. Spec target service is the Emails API
 * (POST /PrePayTenderFailure). See api-routes TODO regarding host config.
 */
export const prepayCustomerSchema = z.object({
	customerName: z.string(),
	customerEmail: z.string(),
	brokerEmail: z.string(),
	ltlBrokerEmail: z.string(),
});

export type PrepayCustomer = z.infer<typeof prepayCustomerSchema>;

// Both notification endpoints return an empty body on success.
export const prepayNotificationResponseSchema = z.object({}).passthrough();

export type PrepayNotificationResponse = z.infer<
	typeof prepayNotificationResponseSchema
>;
